import { render, staticRenderFns } from "./SaveContentTypeBtn.vue?vue&type=template&id=29396528&"
import script from "./SaveContentTypeBtn.vue?vue&type=script&lang=ts&"
export * from "./SaveContentTypeBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports